import React from "react"

export default () => (
    <div className="circleA">
        <svg xmlns="http://www.w3.org/2000/svg" width="412" height="412"><path class="circleAsvg" d="M206,0C319.771,0,412,92.229,412,206S319.771,412,206,412,0,319.771,0,206C0,139.558,31.455,80.463,80.587,42.563A204.837,204.837,0,0,1,206,0Z" transform="translate(0 0)"/></svg>
    </div>
)